/* eslint-disable @angular-eslint/no-input-rename */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, NgControl } from '@angular/forms';
import { makeTranslateService } from '../../../../data/services/common/translate/translate-service-factory';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';

@Component({
  selector: 'app-form-field-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-field-error.component.html',
})
export class FormFieldErrorComponent {
  @Input('controlName') formControl: AbstractControl | FormControl | NgControl;

  private translateService = makeTranslateService();

  public get errorMessage(): string | null {
    if (this.mustShowErrorMessage()) return this.getErrorMessage();
    else return null;
  }
  /**
   *
   *
   * 9594core.mjs:6347 ERROR TypeError: Cannot read properties of null (reading 'invalid')
    at FormFieldErrorComponent.mustShowErrorMessage (form-field-error.component.ts:22:29)
    at get errorMessage [as errorMessage] (form-field-error.component.ts:17:14)
    at FormFieldErrorComponent_Template (form-field-error.component.html:2:3)
    at executeTemplate (core.mjs:11828:9)
    at refreshView (core.mjs:11691:13)
    at refreshComponent (core.mjs:12786:13)
    at refreshChildComponents (core.mjs:11481:9)
    at refreshView (core.mjs:11741:13)
    at refreshComponent (core.mjs:12786:13)
    at refreshChildComponents (core.mjs:11481:9)
   */

  private mustShowErrorMessage(): boolean {
    if (!this.formControl) return true;
    return this.formControl?.invalid && this.formControl?.touched;
  }

  private getErrorMessage(): string | null {
    if (!this.formControl)
      return this.translateService.translateKey(LanguageKey.ERROR_IN_THE_CODE);
    if (this.formControl.errors['required'])
      return this.translateService.translateKey(LanguageKey.REQUIRED_FIELD);
    else if (this.formControl.errors['email'])
      return this.translateService.translateKey(
        LanguageKey.INVALID_EMAIL_FORMAT,
      );
    else if (this.formControl.errors['minlength']) {
      const requiredLength =
        this.formControl.errors['minlength'].requiredLength;
      return (
        this.translateService.translateKey(LanguageKey.MUST_BE_A_MINIMUM) +
        ` ${requiredLength} ` +
        this.translateService.translateKey(LanguageKey.CHARACTERS)
      );
    } else if (this.formControl.errors['maxlength']) {
      const requiredLength =
        this.formControl.errors['maxlength'].requiredLength;
      return (
        this.translateService.translateKey(LanguageKey.MUST_BE_A_MAXIMUM) +
        ` ${requiredLength} ` +
        this.translateService.translateKey(LanguageKey.CHARACTERS)
      );
    } else if (this.formControl.errors['pattern']) {
      return this.translateService.translateKey(LanguageKey.INVALID_FORMAT);
    } else if (this.formControl.errors['cnpjNotValid']) {
      return this.translateService.translateKey(LanguageKey.INVALID_CNPJ);
    }

    return null;
  }
}
